export const EMAIL_INVALID_MESSAGE = "The email you entered looks incorrect";
export const REQUIRED_MESSAGE = "Field can't be empty";
export const FIELD_INVALID = "Field is invalid";
export const PHONE_INVALID_MESSAGE = "Invalid phone format";
export const DATE_INVALID_MESSAGE = "Invalid date format";
export const GENERAL_ERROR = "We've encountered some error while processing your request.";
export const CREATE_FUNDRAISER_PAGE_ERROR = "Your team has been created but we've encountered some errors while creating fundraiser:"

export const getMaximumLengthMessage = maxLength => {
    return `Field length should not exceed ${maxLength} characters`;
};